import { useEffect, useState } from "react";
import {
    Button, Box, CircularProgress, CssBaseline, Dialog, DialogContent, DialogTitle,
    Grid, IconButton, InputAdornment, TextField, Typography
} from "@mui/material";
import MetaDecorator from "../services/meta_decorator";
import { Navigate } from "react-router-dom";
import { getApiUrl } from "../services/api_service";
import { Alert } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SendIcon from '@mui/icons-material/Send';
import EmailIcon from '@mui/icons-material/Email';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import NDReferralHeader from "../components/shared/ndreferralheader";
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { darken, styled } from '@mui/material/styles';
import ImageIcon from '@mui/icons-material/Image';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ArticleIcon from '@mui/icons-material/Article';
import VisibilityIcon from "@mui/icons-material/Visibility";
import PreviewRecordDialog from "../components/shared/records/previewrecorddialog";

import Footer from "../components/shared/footer";
import { bodyBg, buttonRed, darkcolor, dialogEditEvent, footerContainer, fullHeight, greencolor, headerText, lightcolor, line, mainGrid, orangecolor, p2color, pcolor, pointer, primaryColor, rcolor, whitecolor } from "../style2";
import BackToTop from "../components/shared/scrollTop";
import ConfirmDialog from "../components/shared/ConfirmDialog";

import { DownloadFormButton } from "../components/shared/downloadformbutton";
import PatientFormAssignmentList from "../components/PatientFormAssignmentList";
import EditReferral from "../pages/editreferral";



export default function ReferralDetails() {
    const { orgCode, referralId } = useParams();
    const [currentEmail, setCurrentEmail] = useState("");
    const [canViewPatientDetails, setCanViewPatientDetails] = useState(false);
    const [showEditDialog, setShowEditDialog] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingDocs, setLoadingDocs] = useState(false);
    const [openUploadDialog, setOpenUploadDialog] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [referralApp, setReferralApp] = useState(null);
    const [forms, setForms] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [patient, setPatient] = useState(null);
    const [redirect, setRedirect] = useState('');
    const [allowSubmit, setAllowSubmit] = useState(null);
    const [allowUpload, setAllowUpload] = useState(null);
    const [showRefferalCompleteModal, setShowReferralCompleteModal] = useState(false);
    const [date, setDate] = useState('');
    const [docDate, setDocDate] = useState(Date.now());
    const [comingSoonDialogOpen, setComingSoonDialogOpen] = useState(false);
    const [previewRecord, setPreviewRecord] = useState(null);
    // State for custom confirmation dialog
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [confirmDialogCallback, setConfirmDialogCallback] = useState(null);
    const [confirmDialogDescription, setConfirmDialogDescription] = useState("");
    const [submitConfirmOpen, setSubmitConfirmOpen] = useState(false);

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setRedirect(`/login/${orgCode}`);
            return;
        }
        setError('');
        //setSuccess('');
        setLoading(true);
        fetch(`${getApiUrl()}/ReferralApp/details/${orgCode}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(data => {
                        setReferralApp(data); // Set the entire application details  
                    });
                } else if (response.status === 401 || response.status === 403) {
                    localStorage.clear();
                    setRedirect(`/login/${orgCode}`);
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to load app details.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            })
    }, [orgCode]);

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
            setCurrentEmail(parsedAuthTokens?.email || ""); // Set current email from tokens
            setCanViewPatientDetails(parsedAuthTokens?.userType === "1" || parsedAuthTokens?.userType === 1);
        }
        if (!token) {
            setRedirect(`/login/${orgCode}`);
            return;
        }
        setError('');
        //setSuccess('');
        setLoading(true);
        fetch(`${getApiUrl()}/PatientForm/getbyreferral/${referralId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(data => {
                        setForms(data.forms);
                        setPatient(data.referral)
                        //setAllowSubmit(data.allowSubmit);
                        setAllowSubmit(true); // Temporarily allow submission regardless of questionnaire completion while testing

                        setAllowUpload(data.allowUpload);
                    });
                } else if (response.status === 401 || response.status === 403) {
                    localStorage.clear();
                    setRedirect(`/login/${orgCode}`);
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            })
    }, [referralId, date]);

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setRedirect(`/login/${orgCode}`);
            return;
        }
        setError('');

        setLoadingDocs(true);
        fetch(`${getApiUrl()}/referraldocument/${referralId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(data => {
                        setDocuments(data);
                    });
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to load documents.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoadingDocs(false);
            })
    }, [referralId, docDate]);

    const submitReferral = () => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setRedirect(`/login/${orgCode}`);
            return;
        }
        setLoadingSubmit(true);
        setError('');

        fetch(`${getApiUrl()}/Patientreferral/setreferralcomplete/${referralId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                if (response.status === 200) {
                    setSubmitConfirmOpen(false);
                    setShowReferralCompleteModal(true);
                    setAllowSubmit(false);
                    setAllowUpload(false);
                    setDate(Date.UTC());
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoadingSubmit(false);
            })
    }

    // Custom confirmation dialog logic
    const handleRemoveDocument = (documentId) => {
        setConfirmDialogDescription("Are you sure you want to remove this document? This action cannot be undone.");
        setConfirmDialogCallback(() => () => executeRemoveDocument(documentId));
        setConfirmDialogOpen(true);
    };

    const executeRemoveDocument = async (documentId) => {
        setConfirmDialogOpen(false);
        const authTokens = localStorage.getItem("authTokens");
        let token;
        if (authTokens) {
            try {
                const parsedAuthTokens = JSON.parse(authTokens);
                token = parsedAuthTokens?.accessToken;
            } catch (err) {
                setError("Invalid authentication tokens.");
                return;
            }
        }
        if (!token) {
            setError("No authentication token found.");
            return;
        }
        setLoadingDocs(true);
        setError("");
        try {
            const response = await fetch(`${getApiUrl()}/referraldocument/remove/${documentId}`, {
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.ok) {
                setDocDate(new Date());
            } else {
                const data = await response.json().catch(() => ({}));
                setError(data.error || "Unable to remove document.");
            }
        } catch (err) {
            setError("Unable to contact server.");
        } finally {
            setLoadingDocs(false);
        }
    };

    const endsWith = (source, target) => {
        return source.indexOf(target, source.length - target.length) !== -1;
    }

    const handleComingSoonDialogOpen = (r) => {
        setComingSoonDialogOpen(true);
        setPreviewRecord(r);
    };

    const handleComingSoonDialogClose = () => {
        setComingSoonDialogOpen(false);
        setPreviewRecord(null);
    };

    if (redirect !== "")
        return <Navigate to={redirect} replace />;

    return <Box sx={{ ...bodyBg, ...fullHeight }}>
        <CssBaseline />
        <MetaDecorator title={"EnrichMyCare - Make A Referral"} description={"EnrichMycare Make Refferal"} />
        <NDReferralHeader orgCode={orgCode} logo="../../../logo.jpg" />
        <Box pt={1} sx={{ ...bodyBg, marginTop: "5px" }} p={5}>
            {patient !== null ? <><Grid container sx={{ flexGrow: 1 }} spacing={0}>
                <Grid size={6} item>
                    <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1.5, marginTop: "15px" }}>
                        <Typography variant="h5" sx={{ ...headerText, fontWeight: "bold", fontSize: "2rem" }}>{patient.firstName} {patient.surName}
                            {!patient.isSubmitted && forms !== null && forms.length > 0 && (() => {
                            const hasInProgress = forms.some(f => f.status === 1 || f.status === 2);
                            const allComplete = forms.every(f => f.status === 3 || f.status === 4);
                            if (hasInProgress) return <span style={{paddingLeft:"10px", fontSize:"1.3rem"}}>(In progress)</span>;
                            if (allComplete) return <span style={{paddingLeft:"10px", fontSize:"1.3rem"}}>(Awaiting submission)</span>;
                            return null;
                        })()}
                        </Typography>
                        
                    </Box>
                    <Box sx={{ marginTop: 3 }}>
                        <Typography component="span" sx={{ marginRight: 3, fontSize: "1.5rem" }}>DOB: {dayjs(patient.dob).format("DD/MM/YYYY")},</Typography>
                        <Typography component="span" sx={{ fontSize: "1.5rem" }}>NHS Number: {patient.nhsNumber}</Typography>
                    </Box>
                    
                </Grid>
                <Grid size={6} item>
                    <Box mb={1} mt={2} sx={{ textAlign: "right" }}>
                        {canViewPatientDetails && allowUpload ? <Button disabled={loadingDocs || patient.isSubmitted} onClick={() => { setOpenUploadDialog(true); }}
                            sx={{
                                border: `1px solid ${rcolor}`, background: rcolor, color: whitecolor, fontSize: "1.1rem",
                                height: "40px", borderRadius: "20px", paddingLeft: "15px", paddingRight: "15px"
                            }}> Upload</Button> : null}

                        {canViewPatientDetails && <Button onClick={() => setSubmitConfirmOpen(true)}
                            title={allowSubmit === true ? "" : "Please complete and submit all questionnaires before submitting the referral."}
                            disabled={loading || loadingSubmit || allowSubmit !== true || patient.isSubmitted}
                            sx={{
                                marginLeft: "20px",
                                border: allowSubmit === true ? `1px solid ${rcolor}` : `1px solid ${whitecolor}`,
                                background: allowSubmit === true ? rcolor : whitecolor,
                                color: allowSubmit === true ? whitecolor : "grey", fontSize: "1.1rem",
                                paddingLeft: "15px", paddingRight: "15px",
                                height: "40px", borderRadius: "20px"
                            }}>{loadingSubmit ? <CircularProgress color="inherit" size="20px" marginRight={1} /> : null} Submit Referral</Button>}
                    </Box>
                </Grid>
            </Grid>
            {patient && patient.isSubmitted ? <Alert severity="success" sx={{ marginTop: 3, maxWidth: "fit-content" }}>
                        Referral pack submitted to {referralApp && referralApp.details ? referralApp.details.serviceName : "service"} on <strong>{dayjs(patient.submissionDate).format("DD/MM/YYYY")}</strong>. This record is now view-only. A confirmation email has been sent to your registered address.</Alert> : null    }
            </> : null}
            {error !== "" ? <Box sx={{ padding: "10px 0px" }}><Alert severity="error">{error}</Alert></Box> : null}

            {/* SENCO Forms Section */}
            {loading ? <Box sx={{ padding: "10px 0px" }}><CircularProgress color="inherit" size="20px" marginRight={1} /> Loading Forms</Box> : null}
            {!loading && <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "30px", marginBottom: "20px" }}>
                <Typography variant="h5" sx={{ ...headerText, fontWeight: "bold", fontSize: "1.5rem" }}>SENCO Forms</Typography>
            </Box>}
            {forms !== null && forms.filter(form => form.assigneeEmail !== null && form.assigneeEmail.trim() !== "").map((form, index) => (
                <FormCard key={index} form={form} orgCode={orgCode} onNavigate={(id) => setRedirect(`/processform/${orgCode}/${id}`)} showAssignments={canViewPatientDetails} referralId={patient.id ?? null} />
            ))}

            {/* Parent Forms Section */}
            {!loading && canViewPatientDetails && <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "40px" }}>
                <Typography variant="h5" sx={{ ...headerText, fontWeight: "bold", fontSize: "1.5rem" }}>Parent Forms</Typography>
                {canViewPatientDetails && <Button onClick={() => setShowEditDialog(true)} sx={{ border: `1px solid ${rcolor}`, background: rcolor, color: whitecolor, height: "36px", borderRadius: "20px", paddingLeft: "15px", paddingRight: "15px", textTransform: "unset" }}>Patient Details</Button>}
            </Box>}
            {canViewPatientDetails && forms !== null && forms.filter(form => !form.assigneeEmail || form.assigneeEmail.trim() === "").map((form, index) => (
                <FormCard key={index} form={form} orgCode={orgCode} onNavigate={(id) => setRedirect(`/processform/${orgCode}/${id}`)} />
            ))}
            {canViewPatientDetails  ? <>
                <Typography variant="h5" sx={{ ...headerText, marginTop: "15px", fontWeight: "bold", fontSize: "1.5rem" }}>Uploaded Documents</Typography>
                {loadingDocs ? <Box sx={{ padding: "10px 0px" }}><CircularProgress color="inherit" size="20px" marginRight={1} /> Loading Documents</Box> : null}

                <Box sx={{ ...mainGrid, marginTop: "10px", padding: "20px" }}>
                    {(documents === null || documents.length === 0) && !loadingDocs ? <Box sx={{ padding: "10px 0px" }}><Alert severity="info">No documents uploaded.</Alert></Box> : null}
                    {documents !== null && documents.map((record, index) => {
                        return <Box sx={{ paddingX: 0 }}>
                            <Box>
                                <Grid container sm spacing={2} alignItems="center" sx={{ flexGrow: 1, minHeight: 80 }}>
                                    <Grid item size={9} alignContent="center">
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            {record.mime.indexOf("image/") > -1 ? <ImageIcon style={{ fontSize: 50, color: "rgba(17, 92, 113, 0.6)" }} /> : null}
                                            {record.mime.indexOf("audio/") > -1 ? <AudioFileIcon style={{ fontSize: 50, color: "rgba(17, 92, 113, 0.6)" }} /> : null}
                                            {record.mime.indexOf("video/") > -1 ?
                                                <OndemandVideoIcon style={{ fontSize: 50, color: "rgba(17, 92, 113, 0.6)" }} /> : null}
                                            {record.mime.indexOf("application/") > -1 && (endsWith(record.displayName, ".pdf")) ?
                                                <PictureAsPdfIcon style={{ fontSize: 50, color: "rgba(17, 92, 113, 0.6)" }} /> : record.mime.indexOf("application/") > -1 ?
                                                    <ArticleIcon style={{ fontSize: 50, color: "rgba(17, 92, 113, 0.6)" }} /> : null}
                                            <Box>
                                                <Typography style={{
                                                    fontWeight: "normal",
                                                    fontSize: 16,
                                                    color: pcolor
                                                }}>
                                                    {record.displayName}
                                                </Typography>
                                                <Typography display="inline" style={{
                                                    fontWeight: "normal",
                                                    fontSize: 12,
                                                    color: darkcolor,
                                                }}> Date: {dayjs(record.createdAt).format("DD/MM/YY")} </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item size={3} justifyContent="flex-end" alignContent="center" textAlign="right">
                                        <IconButton disabled={loadingDocs} edge="end" aria-label="Download" sx={{marginRight: "20px"}} onClick={() => handleComingSoonDialogOpen(record)}>
                                            <VisibilityIcon />
                                        </IconButton>
                                    
                                        <IconButton disabled={loadingDocs || patient.isSubmitted} sx={{ marginLeft: "20px" }} edge="end" aria-label="Remove"
                                            onClick={() => handleRemoveDocument(record.id)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={line} />
                        </Box>
                    })}

                </Box>
            </> : null}
            {/* Submit Referral Confirmation Dialog */}
            <Dialog
                open={submitConfirmOpen}
                onClose={(_, reason) => { if (reason !== "backdropClick") setSubmitConfirmOpen(false); }}
                disableEscapeKeyDown
                maxWidth="sm"
                fullWidth
                PaperProps={{ sx: { borderRadius: "12px", padding: "8px" } }}
            >
                <DialogContent sx={{ padding: "24px 28px 20px" }}>
                    {/* Title */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, marginBottom: "16px" }}>
                        <SendIcon sx={{ color: pcolor, fontSize: "1.4rem" }} />
                        <Typography sx={{ fontWeight: "bold", fontSize: "1.1rem", color: pcolor }}>
                            Referral pack ready to submit for {patient ? `${patient.firstName} ${patient.surName}` : ""}
                        </Typography>
                    </Box>
                    {referralApp ? <>

                        <Typography sx={{ fontSize: "0.95rem", marginBottom: "10px", color: "#333" }}>
                            The complete referral pack will be securely submitted to the{" "}
                            <strong>{referralApp.details.serviceName}</strong> team at {referralApp.organization.name}:
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                            <EmailIcon sx={{ fontSize: "1rem", color: pcolor, marginRight: "6px" }} />
                            <Typography component="span" sx={{ fontSize: "0.95rem", color: pcolor, fontWeight: "500" }}>
                                {referralApp.details.completionEmails.map((o, index) => (
                                    <span style={{ display: "block" }} key={index}>{o.email}</span>
                                ))}
                            </Typography>
                        </Box>
                        {referralApp.details.serviceLinkURL ? <Box sx={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                            <OpenInNewIcon sx={{ fontSize: "0.95rem", color: pcolor, marginRight: "6px" }} />
                            <Typography
                                component="a"
                                href={referralApp.details.serviceLinkURL}
                                target="_blank"
                                rel="noreferrer"
                                sx={{ fontSize: "0.9rem", color: pcolor }}
                            >
                                {referralApp.details.serviceLinkText ?? "Visit service website"}
                            </Typography>
                        </Box> : null}

                    </> : null}

                    <Typography sx={{ fontSize: "0.8rem", color: "#555", marginBottom: "16px" }}>
                        The pack includes all completed SENCO and Parent/Carer forms, and all uploaded supporting documents.
                    </Typography>

                    {/* Divider */}
                    <Box sx={{ borderTop: "1px solid #ddd", marginBottom: "14px" }} />

                    {/* Note */}
                    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, marginBottom: "22px", backgroundColor: "#f4f9fa", borderRadius: "8px", padding: "12px 14px" }}>
                        <InfoOutlinedIcon sx={{ fontSize: "1.1rem", color: pcolor, marginTop: "2px", flexShrink: 0 }} />
                        <Typography sx={{ fontSize: "0.85rem", color: "#444" }}>
                            A confirmation email will be sent to your registered email address as acknowledgement. The date and time of submission will also be recorded in the referral app.
                        </Typography>
                    </Box>
                    {error !== "" ? <Box sx={{ padding: "10px 0px", my: 2 }}><Alert severity="error">{error}</Alert></Box> : null}
                    {/* Actions */}
                    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                        <Button disabled={loadingSubmit}
                            onClick={() => setSubmitConfirmOpen(false)}
                            sx={{
                                border: "1px solid #ccc", color: "#555", borderRadius: "20px",
                                paddingLeft: "20px", paddingRight: "20px", textTransform: "none"
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => { submitReferral(); }}
                            disabled={loadingSubmit}
                            sx={{
                                background: pcolor, color: "#fff", borderRadius: "20px",
                                paddingLeft: "20px", paddingRight: "20px", textTransform: "none",
                                '&:hover': { background: darken(pcolor, 0.2) }
                            }}
                        >
                            {loadingSubmit ? <CircularProgress color="inherit" size="16px" sx={{ marginRight: 1 }} /> : null}
                            Confirm submission
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>

            <Dialog
                open={showRefferalCompleteModal}
                onClose={() => { setShowReferralCompleteModal(false); }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    <Typography style={{ fontSize: "1.3rem", fontWeight: "bold" }}>Referral successfully submitted</Typography>
                </DialogTitle>
                <DialogContent>
                    <Box style={{ fontSize: "1.2rem", padding: "10px 0px" }}>
                        The referral pack for {patient ? `${patient.firstName} ${patient.surName}` : 'the patient'}
                        has been sent to {referralApp ? referralApp.details.completionEmails.map((o, index) => (
                            <span style={{ marginRight: 1, display:"block" }} key={index}>{o.email}</span>
                        )) : null}</Box>
                    <Box style={{ fontSize: "1.2rem", padding: "10px 0px" }}>
                        If the referral is accepted, the child's family will be contacted with information
                        about waiting times and next steps.</Box>
                    <Box style={{ fontSize: "1.2rem", padding: "10px 0px" }}>
                        A confirmation email has been sent to your registered address.  If you have questions, contact the SPOA team</Box>
                    <Box style={{ fontSize: "1.2rem", padding: "10px 0px" }}>at email:
                        {referralApp ? referralApp.details.completionEmails.map((o, index) => (
                            <a href={`mailto:${o.email}`} style={{ marginRight: 1 }} key={index}>{o.email}</a>
                        )) : null} or telephone: 0300 7900 264</Box>

                    <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
                        <Button
                            onClick={() => setShowReferralCompleteModal(false)}
                            sx={{
                                borderRadius: "20px",
                                paddingLeft: "20px", paddingRight: "20px", textTransform: "none",
                                border: `1px solid ${rcolor}`,
                                background: rcolor,
                                color: whitecolor, fontSize: "1.1rem",
                            }}>
                            Done
                        </Button>

                    </Box>
                </DialogContent>
            </Dialog>

            {/* Custom confirmation dialog for document removal */}
            <ConfirmDialog
                open={confirmDialogOpen}
                title="Confirm Removal"
                description={confirmDialogDescription}
                confirmText="Remove"
                cancelText="Cancel"
                onConfirm={confirmDialogCallback}
                onCancel={() => setConfirmDialogOpen(false)}
            />
            <PreviewRecordDialog open={comingSoonDialogOpen} handleClose={handleComingSoonDialogClose} record={previewRecord} />
            <EditReferral
                disabled={
                    (patient && patient.isSubmitted) ||
                    (forms !== null && !forms.filter(form => !form.assigneeEmail || form.assigneeEmail.trim() === "").some(f => f.status === 1))
                }
                open={showEditDialog}
                onClose={() => setShowEditDialog(false)}
                onSaved={() => { setDate(new Date()); }}
                orgCode={orgCode}
                referralId={referralId}
            />
            {openUploadDialog ? <ReferralDocUpload uploadCount={documents === null ? 0 : documents.length} patientReferralId={referralId} onClose={() => {
                setOpenUploadDialog(false);
            }} onSaved={() => { setOpenUploadDialog(false); setDocDate(new Date()) }} /> : null}
        </Box>
        <BackToTop />
        <Box style={{ ...footerContainer, position: "static" }}>
            <Footer />
        </Box>
    </Box>;
}

function getFormStatus(form) {
    if (form.status === 1) return { label: 'Assigned', date: dayjs(form.assignedAt).format('DD/MM/YYYY'), statusText: 'Assigned' };
    if (form.status === 2) return { label: 'Assigned', date: dayjs(form.assignedAt).format('DD/MM/YYYY'), statusText: 'In Progress' };
    if (form.status === 3) return { label: 'Started', date: dayjs(form.answerStartDate).format('DD/MM/YYYY'), statusText: `Completed (${dayjs(form.answerSubmitDate).format('DD/MM/YYYY')})` };
    if (form.status === 4) return { label: 'Started', date: dayjs(form.answerStartDate).format('DD/MM/YYYY'), statusText: `Submitted (${dayjs(form.answerCompleteDate).format('DD/MM/YYYY')})` };
    return null;
}

function FormCard({ form, orgCode, onNavigate, showAssignments, referralId }) {
    const statusInfo = getFormStatus(form);
    return (
        <Box mb={3} sx={{ background: whitecolor, border: `1px solid ${pcolor}`, borderRadius: 8, p: 3, mt: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'flex-start', justifyContent: 'space-between' }}>
                <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                        <Typography variant="h6" style={{ paddingRight: '20px', fontWeight: 'bold' }}>
                            {form.title}
                        </Typography>
                        {form.status === 1 ? <CheckCircleOutlineIcon title="Form Assigned" sx={{ color: rcolor }} /> : null}
                        {form.status === 2 ? <CheckCircleOutlineIcon color="info" title="Form InProgress" /> : null}
                        {form.status === 3 || form.status === 4 ? <CheckCircleOutlineIcon title="Submitted/Complete" color="success" /> : null}
                    </Box>
                    {statusInfo && (
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} mt={1} mb={1}>
                            <Typography>{statusInfo.label}: </Typography>
                            <Typography style={{ marginLeft: '5px', marginRight: '20px', color: p2color }}>{statusInfo.date}</Typography>
                            <Typography>Status: </Typography>
                            <Typography style={{ marginLeft: '5px', marginRight: '20px', color: p2color }}>{statusInfo.statusText}</Typography>
                        </Box>
                    )}
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1, mt: { xs: 1, md: 0 }, flexShrink: 0 }}>
                    <DownloadFormButton sx={{ marginRight: 2, color: rcolor }} form={form} />
                    <IconButton sx={{ marginLeft: 2 }} onClick={() => onNavigate(form.id)}>
                        <PlayCircleOutlineIcon sx={{ fontSize: '2rem', color: rcolor }} />
                    </IconButton>
                </Box>
            </Box>
            {showAssignments && <PatientFormAssignmentList formId={form.id} referralId={referralId} />}
        </Box>
    );
}

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
function ReferralDocUpload({ onClose, onSaved, patientReferralId, uploadCount }) {
    const maxFileUploadLimit = 4;
    const [attachments, setAttachments] = useState([]);
    const [date, setDate] = useState(Date.now());
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [maxFileUploadATime, setMaxFileUploadAtATime] = useState(maxFileUploadLimit);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (uploadCount < maxFileUploadLimit) {
            setMaxFileUploadAtATime(maxFileUploadLimit - uploadCount);
        } else {
            setMaxFileUploadAtATime(0);
        }
    }, [uploadCount]);

    const saveAttachments = () => {
        if (attachments === null || attachments.length === 0) {
            setError("Please upload some files.");
            return;
        }
        else {
            let validext = ".jpg,.jpeg,.png,.mp3,.mp4,.pdf,.doc,.docx";
            for (let k = 0; k < attachments.length; k++) {
                if (validext.indexOf(attachments[k].ext) === -1) {
                    setError("Invalid file format, please upload in jpg, jpeg, png, mp3, mp4, pdf, doc and docx formats.");
                    return;
                }
            }
        }
        const fd = new FormData();
        for (let k = 0; k < attachments.length; k++) {
            fd.append(`Files[${k}].File`, attachments[k].file);
            fd.append(`Files[${k}].Name`, `${encodeURIComponent(attachments[k].name)}.${attachments[k].ext}`);
            fd.append(`Files[${k}].DocumentType`, 3); // Assuming 3 is the type for referral documents
        }

        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setError("Unauthorized. No token available.");
            setLoading(false);
            return;
        }
        setLoading(true);
        setError("");
        setSuccess("");
        let url = `${getApiUrl()}/ReferralDocument/upload/${patientReferralId}`;
        fetch(url,
            {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: fd
            }
        )
            .then((response) => {
                if (response.status === 200) {
                    setAttachments([]);
                    setError("");
                    setSuccess("Documents uploaded successfully");
                    setTimeout(() => { onSaved(); }, 1500);

                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                    }).catch(err => {
                        setError(err.message || "An error occurred.");
                        console.log(err);
                    });
                }
            })
            .catch((err) => { setError(err.message || "An error occurred."); console.log(err); })
            .finally(() => { setLoading(false); });
    }

    return <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
        <Box sx={{ ...dialogEditEvent, backgroundColor: lightcolor, border: "1px solid #D9D9D9" }}>
            <Grid container align="center" sx={{ flexGrow: 1, textAlign: "left" }} spacing={0}>
                <Grid item size={11}>
                    <Typography sx={{ color: pcolor, fontWeight: "bold", fontSize: "20px", textTransform: "capitalize" }}>
                        Document Upload
                    </Typography>
                </Grid>
                <Grid item size={1} sx={{ ...pointer, color: rcolor, textAlign: "right" }}>
                    <CloseIcon onClick={() => {
                        if (!loading) {
                            onClose();
                        }
                    }} sx={{ width: "35px", height: "35px" }} />
                </Grid>
            </Grid>
            <DialogContent sx={{ padding: "5px" }}>
                {maxFileUploadATime > 0 ? <Box sx={{ backgroundColor: "#ffffff", padding: "8px 15px", marginBottom: "20px", borderRadius: "15px", marginTop: "10px", marginBottom: "10px" }}>
                    <Grid container sx={{ flexGrow: 1 }} spacing={0}>
                        <Grid item size={6}>
                            <Typography sx={{ marginTop: "10px", color: pcolor }}>
                                Upload up to {maxFileUploadATime} documents, each no larger than 50 MB.
                            </Typography>
                        </Grid>
                        <Grid item size={6} sx={{ textAlign: "center" }}>
                            <Button disabled={loading} component="label" color="primary" size="large" style={{ backgroundColor: rcolor, color: whitecolor, borderRadius: "15px", marginTop: "10px" }} role={undefined} variant="contained" tabIndex={-1} startIcon={<CloudUploadIcon />}> Choose file(s)
                                <VisuallyHiddenInput multiple={true} type="file"
                                    accept=".jpg, .png, .doc, .docx, .jpeg, .pdf, .mov, .mp3, .mp4" onChange={(e) => {
                                        setError("");
                                        let temp = attachments;
                                        for (let k = 0; k < e.target.files.length; k++) {
                                            if (e.target.files[k].size / (1024 * 1024) > 50) {
                                                setError("File size exceeds 50 MB limit.");
                                                return;
                                            }
                                            if (temp.length < maxFileUploadATime) {
                                                let n = e.target.files[k].name.split('.').shift();
                                                if (temp.filter(x => x.name === n).length > 0) {
                                                    setError(`File with name "${n}" already exists. Please choose other file and try again.`);
                                                    continue;
                                                }
                                                temp.push({
                                                    file: e.target.files[k],
                                                    name: e.target.files[k].name.split('.').shift(),
                                                    ext: e.target.files[k].name.split('.').pop(),
                                                    documentType: 1
                                                });
                                            } else {
                                                setError(`Only ${maxFileUploadATime} files accepted to upload.`);
                                                break;
                                            }
                                        }
                                        setAttachments(temp);
                                        setDate(new Date());

                                    }} />
                            </Button>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 5, marginBottom: 5 }}>
                            {/* <LinearProgress variant="determinate" value={(attachments.length/maxFileUploadATime) * 100} /> */}
                            <Typography style={{ fontSize: "14px", fontWeight: "bold" }}>Uploaded Documents: ({attachments.length}/{maxFileUploadATime})</Typography>
                        </Grid>
                    </Grid>
                </Box> : null}
                <div>
                    {attachments.map((item, index) => {
                        return <Box style={{ padding: "8px", marginTop: "10px", backgroundColor: "#ffffff", paddingTop: '20px', borderRadius: "15px" }} data-date={date}>
                            <Grid container sx={{ flexGrow: 1 }} spacing={0}>
                                <Grid item size={6}>
                                    <TextField disabled={loading} error={item.name === ""} helperText={item.name === "" ? "Required" : ""} label="File Name" variant="outlined" fullWidth value={item.name} onChange={(e) => {
                                        attachments[index].name = e.target.value;
                                        setAttachments(attachments);
                                        setDate(new Date());
                                    }} InputProps={{
                                        endAdornment: <InputAdornment position="start">.{item.ext}</InputAdornment>,
                                        maxLength: 200
                                    }} />
                                </Grid>
                                <Grid item size={1} sx={{ textAlign: "right" }}>
                                    <IconButton disabled={loading} aria-label="delete" onClick={() => {
                                        let temp = attachments;
                                        temp.splice(index, 1);
                                        setAttachments(temp);
                                        setError("");
                                        setDate(new Date());
                                    }}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>

                        </Box>
                    })}
                    {maxFileUploadATime === 0 ? <Typography style={{ textAlign: "center", color: "red", padding: "4px" }}>You have reached the maximum limit of {maxFileUploadLimit} documents.</Typography> : null}
                    {error !== "" ? <Box style={{ textAlign: "center", color: "red", padding: "4px" }}>{error}</Box> : null}
                    {success !== "" ? <Box style={{ textAlign: "center", color: "green", padding: "4px" }}>{success}</Box> : null}
                </div>
                {attachments.length > 0 ? <Box style={{ padding: "8x", marginTop: "10px", textAlign: "center" }}>
                    {loading ? <CircularProgress color="success" /> : <Button type="button" disabled={loading} sx={buttonRed} onClick={() => {
                        saveAttachments()
                    }}>Submit</Button>}
                </Box> : null}

            </DialogContent>
        </Box>
    </Dialog>;
}